/**
 * M2 Phase 11 Plan 1 (UI-M2-02) — Tenant slug constants.
 *
 * The slug values mirror the Keycloak `tenant_id` user-attribute claim emitted
 * on every authenticated access token, and match the `Slug` column on the
 * `Tenants` DB table seeded by the API in Phase 9 (cover3d-direct id=1, tryba
 * id=2). Using these constants instead of inline strings prevents typos and
 * gives a single grep target when a tenant slug needs to be renamed.
 *
 * Adding a new tenant is a deliberate cross-cutting change (Keycloak user
 * attribute + DB Tenants row + this constant block + UI display name) — the
 * locked M2 set is two tenants.
 */
export const TENANT_SLUGS = {
  COVER3D_DIRECT: 'cover3d-direct',
  TRYBA: 'tryba'
} as const;

export type TenantSlug = typeof TENANT_SLUGS[keyof typeof TENANT_SLUGS];

/**
 * Human-readable label rendered in admin UI surfaces (tenant chip, headers,
 * dialogs). Fallback in callsites should be the raw slug.
 */
export const TENANT_DISPLAY_NAMES: Record<string, string> = {
  [TENANT_SLUGS.COVER3D_DIRECT]: 'Cover3D',
  [TENANT_SLUGS.TRYBA]: 'Tryba'
};
